export const RESPONSIVE_BUTTON_DEFAULT_TEST_ID = 'responsive-button.ui.responsive-button';
